import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorTooltip`

export default defineMessages({
  preferredVendorLabel: {
    id: `${scope}.preferredVendorLabel`,
    defaultMessage: 'Preferred',
  },
  pendingRequestLabel: {
    id: `${scope}.pendingRequestLabel`,
    defaultMessage: 'Vendor requested',
  },
  contactNameLabel: {
    id: `${scope}.contactNameLabel`,
    defaultMessage: 'Contact rep name',
  },
  phoneLabel: {
    id: `${scope}.phoneLabel`,
    defaultMessage: 'Phone',
  },
  emailLabel: {
    id: `${scope}.emailLabel`,
    defaultMessage: 'Email',
  },
  vendorIdLabel: {
    id: `${scope}.vendorIdLabel`,
    defaultMessage: 'Vendor ID',
  },
  tooltipTitle: {
    id: `${scope}.tooltipTitle`,
    defaultMessage: 'Vendor details',
  },
})
